import { render, staticRenderFns } from "./recruitment.vue?vue&type=template&id=e04890e4&scoped=true&"
import script from "./recruitment.vue?vue&type=script&lang=js&"
export * from "./recruitment.vue?vue&type=script&lang=js&"
import style0 from "./recruitment.vue?vue&type=style&index=0&id=e04890e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04890e4",
  null
  
)

export default component.exports